// Dependencies
global.jQuery = require('jquery');
require('bootstrap/js/modal');
var _ = require('underscore');

// App
var FormView = require('app/common/views/form-view');

var ModalFormView = FormView.extend({
    className: 'modal',

    _modalFormViewUi: {
        modalBody: '[data-ui="modalBody"]',
        modalFooter: '[data-ui="modalFooter"]',
        closeModal: '[data-ui="closeModal"]',
    },

    _modalFormViewEvents: {
        'click @ui.closeModal': 'closeModal',
    },

    constructor: function(options) {
        this.events = _.extend({}, this._modalFormViewEvents, this.events);
        this.ui = _.extend({}, this._modalFormViewUi, this.ui);
        FormView.prototype.constructor.call(this, options);
    },

    closeModal: function() {
        this.$el.modal('hide');
    },

    onSubmitSuccess: function() {
        this.ui.modalBody.html(this.successTemplate());
        this.ui.modalFooter.remove();

        setTimeout(_.bind(this.closeModal, this), 10000);
    },
});

module.exports = ModalFormView;
